module.exports = __webpack_public_path__ + "static/brand-meanwell-cc332e57ef60b6cc06303b4cc7b13272.png";